module.exports = __webpack_public_path__ + "img/cpzz6@2x.04a654f6.png";